const P = "https://images.pexels.com/photos";

export const SERVICES = [
  {
    slug: "car-lockouts",
    name: "Car Lockouts",
    title: "Car Lockout Service in Winnipeg | 24/7 Damage-Free Entry — Arrow Locksmith",
    meta: "Locked out of your car in Winnipeg? Arrow Locksmith provides 24/7 damage-free car lockout service across Winnipeg with about a 20 minute average response. Call (204) 963-9081.",
    h1: "Car Lockout Service in Winnipeg",
    img: `${P}/4592222/pexels-photo-4592222.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940`,
    alt: "Hand gripping a car door handle on a rainy day in Winnipeg",
    intro:
      "Keys on the seat, engine running, trunk slammed shut — it happens to everyone eventually. Arrow Locksmith runs fully mobile vans across Winnipeg, so a locked car is a short wait, not a ruined day. We open vehicles with professional, non-destructive tools: no bent door frames, no scratched paint, no damaged weather stripping.",
    local:
      "From downtown parkades to the Polo Park lot, The Forks, St. Vital Centre and every residential street in between, our technicians know Winnipeg's neighbourhoods and reach most locations in about 20 minutes — day, night, weekends and holidays, in every month of a Manitoba winter.",
    included: [
      "Non-destructive vehicle entry for all makes and models",
      "Trunk and glovebox opening",
      "On-the-spot spare key cutting if you want a backup",
      "Exact price quoted before we dispatch — no surprises",
    ],
    faqs: [
      {
        q: "How much does a car lockout cost in Winnipeg?",
        a: "It depends on your vehicle and the time of day. Call or text us your location and vehicle and we quote an exact price before we roll — the price we quote is the price you pay.",
      },
      {
        q: "Will you damage my car getting it open?",
        a: "No. We use air wedges, long-reach tools and lock picks designed for vehicle entry. Your door, paint and seals stay untouched.",
      },
      {
        q: "Can you open keyless / push-to-start cars?",
        a: "Yes. Keyless entry systems don't change how the door lock works — we open them the same damage-free way.",
      },
    ],
  },
  {
    slug: "residential-lockouts",
    name: "Residential Lockouts",
    title: "Residential Lockout & Rekey Service in Winnipeg — Arrow Locksmith",
    meta: "Locked out of your house or apartment in Winnipeg? Arrow Locksmith provides 24/7 damage-free home entry, rekeying and lock replacement across Winnipeg. Call (204) 963-9081.",
    h1: "Residential Lockouts & Rekeying in Winnipeg",
    img: `${P}/6689288/pexels-photo-6689288.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940`,
    alt: "Residential front door with a modern smart lock in Winnipeg",
    intro:
      "Locked out of your house, apartment or condo? Arrow Locksmith gets you back inside quickly and without damage — then makes sure it doesn't happen again. If your keys are lost for good, we can rekey or replace your locks on the same visit so the old keys stop working immediately.",
    local:
      "We serve every Winnipeg neighbourhood — from Wolseley character homes and Exchange District condos to new builds in Bridgwater, Sage Creek and Waverley West. Moving into a new place? A same-day rekey is the cheapest security upgrade there is.",
    included: [
      "Damage-free home, apartment and condo entry",
      "Same-visit rekeying so lost keys stop working",
      "Lock replacement and upgrades if hardware is worn",
      "Fresh keys cut on the spot, labelled per door",
    ],
    faqs: [
      {
        q: "Can you open my door without breaking the lock?",
        a: "In the vast majority of cases, yes — we pick or bypass standard residential locks without any damage. Drilling is a last resort and we always ask first.",
      },
      {
        q: "Should I rekey or replace my locks after moving in?",
        a: "If the hardware is in good shape, rekeying is all you need — it's faster and cheaper, and every old key stops working instantly.",
      },
      {
        q: "Do you work on apartments and condos?",
        a: "Yes, as long as you can confirm you live there. For building common areas we'll coordinate with your property manager.",
      },
    ],
  },
  {
    slug: "key-fob-programming",
    name: "Key Fob Programming",
    title: "Car Key Fob Programming in Winnipeg | Mobile Service — Arrow Locksmith",
    meta: "Need a key fob programmed in Winnipeg? Arrow Locksmith programs replacement fobs and remotes on-site for nearly every make — for far less than the dealership. Call (204) 963-9081.",
    h1: "Key Fob Programming in Winnipeg",
    img: `${P}/6565048/pexels-photo-6565048.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940`,
    alt: "Car key fob held in hand ready for programming",
    intro:
      "A dead, lost or broken key fob doesn't have to mean a dealership appointment and a dealership invoice. Arrow Locksmith carries professional programming equipment in every van and pairs new fobs and remotes to your vehicle wherever it's parked — at home, at work, or in a parking lot.",
    local:
      "We program fobs for nearly every make on Winnipeg roads — Ford, Honda, Toyota, Chevrolet, Hyundai, Kia, Nissan, Mazda, Dodge, Jeep, BMW and more. Tell us your year, make and model and we'll confirm coverage and price before dispatch.",
    included: [
      "New fobs and remotes supplied and programmed on-site",
      "Keyless entry and push-to-start systems",
      "Dealer-level programming equipment in every van",
      "Old lost fobs can be erased from the vehicle's memory",
    ],
    faqs: [
      {
        q: "How much does key fob programming cost in Winnipeg?",
        a: "Typically far less than the dealership. The exact price depends on your vehicle — call with your year, make and model for a firm quote before we come out.",
      },
      {
        q: "I lost my only fob. Can you still help?",
        a: "Yes. We can originate and program a brand-new fob from scratch, and erase the lost one so it no longer starts or unlocks your vehicle.",
      },
      {
        q: "Do I need to tow my car anywhere?",
        a: "No. Everything happens where your car sits — driveway, office lot or roadside.",
      },
    ],
  },
  {
    slug: "transponder-smart-keys",
    name: "Transponder & Smart Keys",
    title: "Transponder & Smart Key Replacement in Winnipeg — Arrow Locksmith",
    meta: "Lost your transponder or smart key in Winnipeg? Arrow Locksmith cuts and codes chipped keys on-site, even when all keys are lost — no dealer tow required. Call (204) 963-9081.",
    h1: "Transponder & Smart Key Replacement in Winnipeg",
    img: `${P}/12551173/pexels-photo-12551173.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940`,
    alt: "Modern push-to-start button and smart key system in a vehicle",
    intro:
      "Modern keys are computers. When a transponder or smart key is lost or stops being recognized, your immobilizer won't let the engine start — and most people assume the dealership is the only option. It isn't. Arrow Locksmith cuts and codes chipped keys to your vehicle's immobilizer on the spot, including complete all-keys-lost situations.",
    local:
      "Across Winnipeg and surrounding communities, we originate replacement smart keys where your vehicle sits — no tow truck, no week-long dealer wait, and usually for significantly less money.",
    included: [
      "Transponder keys cut and coded on-site",
      "Smart keys and proximity keys for push-to-start vehicles",
      "All-keys-lost origination — no existing key needed",
      "Immobilizer pairing with dealer-level equipment",
    ],
    faqs: [
      {
        q: "Can you make a transponder key if I've lost every key?",
        a: "Yes. We originate new keys from your vehicle's lock and pair them to the immobilizer — no existing key and no dealership visit required.",
      },
      {
        q: "Is a mobile-programmed key as reliable as a dealer key?",
        a: "Yes. We use the same class of programming equipment and quality key blanks, and we test every key in the doors and ignition before we leave.",
      },
      {
        q: "What do you need from me?",
        a: "Just proof the vehicle is yours (registration or insurance in your name) and photo ID. It's how we keep Winnipeg's vehicles safe.",
      },
    ],
  },
  {
    slug: "broken-key-extraction",
    name: "Broken Key Extraction",
    title: "Broken Key Extraction in Winnipeg | Car & Home — Arrow Locksmith",
    meta: "Key snapped off in your car door, ignition or house lock? Arrow Locksmith extracts broken keys and cuts replacements on the spot, anywhere in Winnipeg. Call (204) 963-9081.",
    h1: "Broken Key Extraction in Winnipeg",
    img: `${P}/115642/pexels-photo-115642.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940`,
    alt: "Close-up of a broken key inside a lock cylinder",
    intro:
      "Keys snap — especially in a Winnipeg January, when metal gets brittle and locks freeze. Whatever you do, don't poke the fragment deeper. Arrow Locksmith extracts broken keys from car doors, ignitions, trunks, house deadbolts and padlocks using proper extractor tools, then cuts you a fresh key on the same visit.",
    local:
      "Frozen locks are a routine call for us every winter from St. Boniface to St. James. If your lock is sticking or your key has a visible crack, replacing it now is far cheaper than an extraction later — ask us on the call.",
    included: [
      "Extraction from car doors, ignitions and trunks",
      "Extraction from residential deadbolts and padlocks",
      "Fresh key cut on the spot from the broken pieces",
      "Lock inspection so the cause — wear or ice — gets fixed too",
    ],
    faqs: [
      {
        q: "Can you make a new key from the broken pieces?",
        a: "Usually yes — if we have both fragments we can decode and cut an exact replacement right in the van.",
      },
      {
        q: "Will extraction damage my lock?",
        a: "No. Extraction tools are designed to grip the fragment without harming the cylinder. If the lock itself caused the break, we'll tell you honestly.",
      },
      {
        q: "My key snapped in the ignition. Now what?",
        a: "Don't try to start the car or dig with tools — call us. We extract the fragment and can cut a working replacement on-site.",
      },
    ],
  },
  {
    slug: "spare-duplicate-keys",
    name: "Spare & Duplicate Keys",
    title: "Spare & Duplicate Car Keys in Winnipeg — Arrow Locksmith",
    meta: "Get spare car keys and duplicates cut in Winnipeg before you're locked out. Arrow Locksmith cuts and programs spare keys at your home or work. Call (204) 963-9081.",
    h1: "Spare & Duplicate Keys in Winnipeg",
    img: `${P}/35578808/pexels-photo-35578808.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940`,
    alt: "Locksmith workshop with key cutting equipment and rows of key blanks",
    intro:
      "One key is one mistake away from a bad day. A spare cut today costs a fraction of an all-keys-lost call tomorrow — and with Arrow Locksmith it happens in your driveway, on your schedule. We duplicate standard keys, high-security keys, transponder keys and remotes for vehicles, plus house keys for your home.",
    local:
      "Bought a used car in Winnipeg that came with a single key? That's our favourite kind of call. We'll cut and code a spare (or two) at your home or office and you'll never think about it again.",
    included: [
      "Spare car keys cut and programmed on-site",
      "House, apartment and padlock key duplication",
      "High-security and laser-cut automotive keys",
      "Volume spares for families and fleets",
    ],
    faqs: [
      {
        q: "Is a spare really cheaper than waiting?",
        a: "Almost always. Duplicating an existing key is simple; originating one after all keys are lost takes more time and equipment — which is why it costs more.",
      },
      {
        q: "Can you duplicate a key marked 'do not duplicate'?",
        a: "For standard residential keys, usually yes. For restricted or high-security systems we'll walk you through the legitimate options.",
      },
      {
        q: "How long does a spare car key take?",
        a: "Most spares are cut, coded and tested in about 30 minutes at your location.",
      },
    ],
  },
];

export const serviceJsonLd = (s, siteUrl) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: s.name,
  name: `${s.name} in Winnipeg`,
  description: s.meta,
  url: `${siteUrl}/services/${s.slug}`,
  provider: { "@id": `${siteUrl}/#business` },
  areaServed: {
    "@type": "City",
    name: "Winnipeg",
    containedInPlace: { "@type": "AdministrativeArea", name: "Manitoba" },
  },
});

export const breadcrumbJsonLd = (s, siteUrl) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: `${siteUrl}/` },
    { "@type": "ListItem", position: 2, name: "Services", item: `${siteUrl}/#services` },
    { "@type": "ListItem", position: 3, name: s.name, item: `${siteUrl}/services/${s.slug}` },
  ],
});

export const faqJsonLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
